/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import { limitReducer,resetArrays } from "../../redux/MultiselectRows"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import { useExportOrganizationUsersMutation, useGetOrganizationUserQuery } from "../../features/organizationUserSlice"
import { handleAddFilterValues, handleSidebarPrvState } from "../../redux/systemConfigSlice"
import TopBarTemplate from "./Components/TopBarTemplate"
import TableTemplate from "./Components/TableTemplate"
import moment from "moment"
import { useDeleteTemplateMutation, useGetMonitorTemplatesQuery } from "../../features/monitorConditionTemplate"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { resetDeviceAlertSearch, setDeviceAlertSearchApplied } from "../../redux/deviceAlertReportSearchSlice"
import DeviceAlertReportsSearch from "../Reports/AlertReport/DeviceAlert/Component/AdvancedSearch"

export default function ManageMonitoringConditionTemplates() {
    const {isSideBar,setIsSideBar,setToastmessage,setToastErrorMessage,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    
    const [exportOrganizationUsers]=useExportOrganizationUsersMutation()
    const [deleteTemplate]=useDeleteTemplateMutation()
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams({});
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [datePartialFilled,setDatePartialFilled]=useState(false)
    const deviceAlertSearch = useSelector(state => state.deviceAlertSearchData);
    const searchApplied = useSelector((state) => state.deviceAlertSearchData.deviceAlertSearchApplied);
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)

    const initialState={
        "start_date":'',
        "end_date":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)

    useEffect(() => {
        const start_date = searchParams.get('start_date')
        const end_date = searchParams.get('end_date')
        if (start_date || end_date) {
            setFilterValues({
                start_date: filtervals?.start_date ?? '',
                end_date: filtervals?.end_date ?? '',
            })
        }
    }, [searchParams, filtervals])

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false});

    const {data,isFetching,isLoading,status}=useGetMonitorTemplatesQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
        }
        // Ensure page_number is a valid number if being set
        if (key === 'page_number' && (isNaN(value) || value < 1)) {
            params[key] = 1
        } else {
            params[key] = value
        }
        setSearchParams({ ...params})
    }
    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }
      
        if(location.state!==null&&location.state!==''&& !Array.isArray(location.state)){
            const params = { limit: '15', page_number: '1', ...location.state }
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params)
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        }
        else{
            // Only initialize default values if no search params exist
            const params = Object.fromEntries(searchParams)
            let changed = false
            if(!params.limit){ params.limit = '15'; changed = true }
            if(!params.page_number){ params.page_number = '1'; changed = true }
            if(changed) setSearchParams(params, { replace: true })
        }

    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=2){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
       
        
    }, [data?.data]);

    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if (type) {
            params.page_number=1
            params.filter = "true";
            const start_date=moment(filterValues?.start_date).format('YYYY-MM-DD')
            const end_date=moment(filterValues?.end_date).format('YYYY-MM-DD')
            
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                start_date: filterValues.start_date,
                end_date: filterValues.end_date
            }));
    
            filterValues?.start_date !== "" && filterValues?.start_date !== undefined ? params["start_date"] = convertDatesToEpochUTC(start_date, Intl.DateTimeFormat().resolvedOptions().timeZone, true) : ''
            filterValues?.end_date !== "" && filterValues?.end_date !== undefined ? params["end_date"] = convertDatesToEpochUTC(end_date, Intl.DateTimeFormat().resolvedOptions().timeZone, false) : ''
            setSearchParams({...params})
        }
        else{
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            delete params.filter
            setSearchParams({ ...params})
        }
    }

    // delete template
    const handleDelete = async (id) => {
        setLoading(true)        
        const res = await deleteTemplate(id)
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message)
            setLoading(false)
        }
        else {
            setToastmessage('Monitoring conditions template deleted successfully');
            setLoading(false)
            
        }
    }

    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
    
        let searchString = '';
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `template name` and `inverse` conditions
        if (deviceAlertSearch?.patient_id && deviceAlertSearch.patient_id.trim() !== '') {
            const patientIdPrefix = deviceAlertSearch.patient_id_inverse ? 'ne:' : '';
            const formattedPatientId = formatSearchValue(deviceAlertSearch.patient_id);
            searchString += `template_name=${patientIdPrefix}${encodeURIComponent(formattedPatientId)};`;
        }

        // check for creted by id field 
        if (deviceAlertSearch?.user_id && deviceAlertSearch.user_id.trim() !== '') {
            const userIDPrefix = deviceAlertSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserID = formatSearchValue(deviceAlertSearch.user_id);
            searchString += `created_by=${userIDPrefix}${encodeURIComponent(formattedUserID)};`;
        }

        const { acknowledge_day, acknowledge_month, acknowledge_year } = deviceAlertSearch || {};

        // Check if only some of the fields are filled
        const isPartialDateFilled =
        (acknowledge_day && (!acknowledge_month || !acknowledge_year)) ||
        (acknowledge_month && (!acknowledge_day || !acknowledge_year)) ||
        (acknowledge_year && (!acknowledge_day || !acknowledge_month));

        if (isPartialDateFilled) {
            setDatePartialFilled(true);
            return;
        } else if (
            acknowledge_day === '--' &&
            acknowledge_month === '--' &&
            acknowledge_year === '----'
        ) {
            // All fields contain dashes, send __NULL__
            const acknowledgeDatePrefix = deviceAlertSearch.acknowledge_date_inverse ? 'ne:' : '';
            searchString += `created_at=${acknowledgeDatePrefix}__NULL__;`;
        } else if (acknowledge_day && acknowledge_month && acknowledge_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${acknowledge_year}-${String(acknowledge_month).padStart(2, '0')}-${String(acknowledge_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00)
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds
            const epochDate = Math.floor(date.getTime() / 1000);
            const acknowledgeDatePrefix = deviceAlertSearch.acknowledge_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `created_at=${acknowledgeDatePrefix}${epochDate};`;
        }     

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceAlertSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            // sort: currentParams.sort || 'created_at+desc', // Keep sort or set default
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setDeviceAlertSearchApplied());
    };

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) { 
            dispatch(resetDeviceAlertSearch());
        }
    }, [dispatch, searchApplied]);
 
    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Monitoring Conditions Templates"}/>
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-3">
                        <TopBarTemplate 
                            title={'List of Monitoring Conditions Templates'}
                            path={'/manage-monitoring-condition-templates/add-template'}
                            AddButton={true}
                            buttonName={"Create Template"}
                            ApplyFilter={((searchParams.get("filter")===null)&&(data?.data?.length===0 || data===undefined))?false:true}
                            toAddScreen={'/manage-monitoring-condition-templates/add-template'}
                            setConfirmationState={setConfirmationState}
                            data={data}
                            isExport={true}
                            exportCols={['Template Name','Created Date','Created By','Last Modified Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            initialState={initialState}
                            exportUsers={exportOrganizationUsers}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleCheckboxChange={handleCheckboxChange}
                            handleApplyFilter={handleApplyFilter}
                            
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Monitoring Conditions Templates list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-3">
                            <TableTemplate
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                setConfirmationState={setConfirmationState}
                                loading={loading}
                                handleDelete={handleDelete}


                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p id="total_records" className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.success_status==="false") || (data?.total_count===0&&(searchParams.get("start_date")!==null|| searchParams.get("search")!==null||searchParams.get("end_date")!==null)) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count===0&&(searchParams.get("start_date")===null||searchParams.get("end_date")===null)?<Emptyscreen
                                title={"Manage Monitoring Conditions Templates"}
                                FirstPTag={"No Monitoring conditions template created yet "}
                                SecondePTag={"Click on ‘Create Template’ to create one"}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                
            </div>
            {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <DeviceAlertReportsSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                    monitorConditionTemplateSearch={true}
                />
            }
        </>
   
    )
}
